import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./RegControl.css";

const RegControl = () => {

  const [pending, setPending] = useState([]);
  const [users, setUsers] = useState([]);

  const navigate = useNavigate();

  const loadData = async () => {

    try {

      const pendingRes = await axios.get(
        "https://streamsrv.n-tools.info/api/admin/pending-registrations"
      );

      const usersRes = await axios.get(
        "https://streamsrv.n-tools.info/api/admin/all-users"
      );

      setPending(pendingRes.data);
      setUsers(usersRes.data);

    } catch (err) {

      console.error("Error loading data", err);

    }

  };

  useEffect(() => {

    loadData();

  }, []);

  const approveUser = async (id) => {

    await axios.post(
      `https://streamsrv.n-tools.info/api/admin/approve/${id}`
    );

    loadData();

  };

  const rejectUser = async (id) => {

    await axios.post(
      `https://streamsrv.n-tools.info/api/admin/reject/${id}`
    );

    loadData();

  };

  const goHome = () => {

    navigate("/home");

  };

  return (

    <div className="regcontrol-container">

      <h2>Registration Control Panel</h2>

      <button className="back-btn" onClick={goHome}>
        ← Back
      </button>


      {/* Pending Requests */}

      <div className="pending-section">

        <h3>Pending Requests</h3>

        {pending.length === 0 ? (

          <p className="no-request">
            No Pending Registration Requests
          </p>

        ) : (

          pending.map((req) => (

            <div className="request-card" key={req.id}>

              <div className="req-info">

                <strong>{req.username}</strong>

                <p>{req.email}</p>

              </div>

              <div className="req-actions">

                <button
                  className="approve-btn"
                  onClick={() => approveUser(req.id)}
                >
                  Approve
                </button>

                <button
                  className="reject-btn"
                  onClick={() => rejectUser(req.id)}
                >
                  Reject
                </button>

              </div>

            </div>

          ))

        )}

      </div>


      {/* Registered Users */}

      <div className="users-section">

        <h3>Registered Users</h3>

        <table className="users-table">

          <thead>

            <tr>

              <th>ID</th>
              <th>Username</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Created</th>

            </tr>

          </thead>

          <tbody>

            {users.map((user) => (

              <tr key={user.id}>

                <td>{user.id}</td>
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td>{user.role}</td>
                <td>{user.status}</td>
                <td>{user.created_at}</td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>

  );

};

export default RegControl;